import React, { useCallback, Fragment } from "react";
import { Button, Modal } from "@shopify/polaris";
import { useMutation } from "@apollo/react-hooks";

import useToggle from "../../../../hooks/useToggle";
import { DELETE_2D_MOCKUP } from "../../../../graphql/mutations";
import { useToastContext } from "../../../shared/ToastContext";
import { handleError } from "../../../../helper";

export function Delete({
    idsChecked,
    handleCompleted,
    isAction = false,
    open: openProp,
    toggleOpen: toggleOpenProp,
}) {
    // Context
    const { toggleToast, setNotify } = useToastContext();

    // State
    const [open, toggleOpen] = useToggle(false);

    // Props
    const onClose = isAction ? toggleOpenProp : toggleOpen;
    const suffix = idsChecked?.length > 1 ? "s" : "";

    // Mutation
    const [delete2dMockup, { loading }] = useMutation(DELETE_2D_MOCKUP, {
        onCompleted: () => {
            setNotify({
                msg: `Delete mockup${suffix} successfully.`,
                err: false,
            });
            onClose && onClose();
            handleCompleted && handleCompleted();
        },
        onError: (err) => {
            setNotify({ msg: handleError(err.toString()), err: true });
        },
    });

    // Handle actions
    const handleSubmit = useCallback(() => {
        if (idsChecked?.length > 0) {
            toggleToast && toggleToast(true);
            setNotify({ msg: null, err: false });
            delete2dMockup({
                variables: {
                    ids: idsChecked,
                },
            });
        }
    }, [idsChecked, delete2dMockup, setNotify, toggleToast]);

    return (
        <Fragment>
            {!isAction && (
                <Button
                    children="Delete Mockups"
                    onClick={toggleOpen}
                    destructive
                />
            )}
            <Modal
                title={`Delete Mockup${suffix}`}
                open={isAction ? openProp : open}
                onClose={onClose}
                sectioned
                primaryAction={{
                    loading: loading,
                    content: "Delete",
                    onAction: handleSubmit,
                    destructive: true,
                }}
                secondaryActions={[
                    {
                        content: "Cancel",
                        onAction: onClose,
                    },
                ]}
            >
                <p>Are you sure to delete to mockup{suffix}?</p>
            </Modal>
        </Fragment>
    );
}
